// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_leaflet-defaulticon-compatibility_src_Icon_Default_compatibility_js-node-a43fe3":"0f7e0fd7a6acb191c2ba","src_views_PhotosTab_vue":"3cc510068564753c0c28"}[chunkId] + "";
};